<template>
  <div class="ui left aligned container">
    <div class="ui right aligned container">
      <button @click="refresh()" class="ui primary mini button" id="refresh"><i class="sync icon"></i></button>
    </div>
    <vuetable ref="vuetable"
              :api-url="'/kugo/albums?albumid=' + albumid"
              :fields="fields"
              data-path="albums"
              @vuetable:load-success="dataLoaded($event)"
    >
    </vuetable>
    <br>
    <div v-if="count">总助燃次数：{{count}}</div>
    <div v-if="total">总购买次数：{{total}}</div>
    <div v-if="total">未助燃次数：{{total - count}}</div>
    <div v-if="time">统计时间：{{time}}</div>
  </div>
</template>
<style>
</style>
<script>
  import Vuetable from '../../table/Vuetable.vue'
  import VuetablePagination from '../../table/VuetablePagination.vue'
  import VuetablePaginationInfo from '../../table/VuetablePaginationInfo.vue'

  export default {
    name: 'KugoAlbumList',
    components: {
      Vuetable,
      VuetablePagination,
      VuetablePaginationInfo,
    },
    data() {
      return {
        count: '',
        total: '',
        time: '',
        albumid: this.$route.params.id || 205382,
        fields: [
          {name: 'name', title: '姓名'},
          {name: 'todayCount', title: '今日助燃次数', sortField: 'todayCount'},
          {name: 'totalCount', title: '总助燃次数', sortField: 'totalCount'},
        ]
      }
    },
    beforeRouteUpdate(to, from, next) {
      this.albumid = to.params.id;
      next();
    },
    methods: {
      dataLoaded: function (event) {
        this.total = event.data.total;
        this.count = event.data.count;
        this.time = new Date(event.data.time).toLocaleString();
      },
      refresh: function () {
        this.$refs.vuetable.reload();
      },
      onPaginationData(paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
        this.$refs.paginationInfo.setPaginationData(paginationData)
      },
      onChangePage(page) {
        this.$refs.vuetable.changePage(page)
      },
      link: function (value, item) {
        return '<a href="https://ep.kugou.com/html/mobile_commonchargeV3/assistance_' + this.albumid + '.html?channalid='
          + item.singerid + '" target="_blank">' + value + '</a>';
      }
    }
  }
</script>
